<template>
    <div class="main-con el-main">
        <router-view />
    </div>
</template>

<script>
    export default {
        name: "RepaymentWithExcessAmount"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/fang/RepaymentWithExcessAmount.vue